import React from 'react'
import Gif from '../gif/workingOn.gif'
export default function WorkingGif() {
  return (
    <div >
      <img src={Gif} alt='work on' />
    </div>
  )
}
